import { createBrowserRouter } from 'react-router';
import MainLayout from './layouts/main/MainLayout';
import HomePage from './pages/main/Home';
import PlayPage from './pages/main/Play';
import PlayShow from './pages/main/PlayShow';
import EventShow from './pages/main/EventShow';
import CoursePage from './pages/main/Course'
import TeamPage from './pages/main/Team';
import TeamShow from './pages/main/TeamShow';
import FoundationPage from './pages/main/Foundation';
import CourseShow from './pages/main/CourseShow';
import PaymentSuccess from './pages/main/PaymentSuccess';
import PaymentCancelled from './pages/main/PaymentCancelled';
import NotFound from './pages/main/NotFound';
import Datenschutz from './pages/main/Datenschutz';
import Impressum from './pages/main/Impressum';
import CourseContract from './pages/main/CourseContract';

export const router = createBrowserRouter([
  {
    path: '',
    Component: MainLayout,
    children: [
      {
        index: true,
        Component: HomePage
      },
      {
        path: 'play',
        Component: PlayPage
      },
      {
        path: 'theater',
        Component: PlayPage
      },
      {
        path: 'plays/:id',
        Component: PlayShow,
      },
      {
        path: "/events/:id",
        Component: EventShow,
      },
      {
        path: 'course',
        Component: CoursePage
      },
      {
        path: 'courses/:slug',
        Component: CourseShow
      },
      {
        path: 'team',
        Component: TeamPage
      },
      {
        path: 'team/:id',
        Component: TeamShow
      },
      {
        path: 'foundation',
        Component: FoundationPage
      },
      {
        path: 'program',
        Component: HomePage
      },
      {
        path: 'payment-success',
        Component: PaymentSuccess
      },
      {
        path: 'payment-cancelled',
        Component: PaymentCancelled
      },
      {
        path: 'datenschutz',
        Component: Datenschutz
      },
      {
        path: 'impressum',
        Component: Impressum
      },
      {
        path: 'kurs-sozlesmesi/:token',
        Component: CourseContract
      },
    ]
  },
  {
    path: '*',
    Component: NotFound
  }
]);